module.exports = __webpack_public_path__ + "static/media/Regnummer.c7bac750.jpg";